import * as React from 'react';
import {Breadcrumb} from '~/components/Breadcrumps';
import {Button} from '~/components/Button';
import {DetailsView} from '~/components/DetailsView';
import {onSubmitError} from '~/components/Form';
import {useModals} from '~/components/Modal';
import {BreadcrumbsResourcePage} from '~/components/ResourcePage';
import {Intent} from '~/lib/intent';
import {changePassword} from '~/modules/Profile/api';
import {ChangePasswordForm} from '~/modules/Profile/forms/ChangePasswordForm';
import {useSession} from '~/modules/Profile/session';

export const ProfileView = () => {
    let {session: {user}} = useSession();

    const modals = useModals();

    const changePasswordForm = modals.create(ChangePasswordForm, {
        passwords: {password: null, current: null},
        onSubmit: (changePasswords, formikActions, close) => {
            changePassword(changePasswords.current, changePasswords.password)
                .then(close).catch(onSubmitError(formikActions));
        }
    }
    );

    return <Breadcrumb breadcrumb={{
        title: 'Profile'
    }}
    >
        <Breadcrumb breadcrumb={{
            title: user.name
        }}
        >
            <BreadcrumbsResourcePage title={user.name} toolbar={
                <Button
                    onClick={() => changePasswordForm.show()}
                    intent={Intent.WARNING}
                    rightIcon={<i className='fa fa-key'/>}
                    responsive>
                    Change password
                </Button>
            }>
                <DetailsView fields={[
                    {label: 'Name', value: user.name},
                    {label: 'Email', value: user.email},
                    {label: 'Company', value: user.company},
                    {label: 'Role', value: user.role}
                ]}/>
            </BreadcrumbsResourcePage>
        </Breadcrumb>
    </Breadcrumb>;
};
